import { MapExtended } from "./map-extended";
import { Component } from '@opten/compiler/metadata/component';
declare var Cookiebot;

@Component({ className: 'js-map-extended' })
export class MapExtendedComponent {
	private mapExtended: MapExtended;
	private static readonly MAX_WAIT_MS = 15000;
	private static readonly POLL_INTERVAL_MS = 100;

	constructor(private element: HTMLElement) {
		if (typeof (Cookiebot) !== 'undefined') {
			if (Cookiebot.consent && Cookiebot.consent.marketing) {
				this.tryInitMapWhenReady();
			}
			window.addEventListener('CookiebotOnAccept', () => {
				if (Cookiebot.consent.marketing && (this.mapExtended == undefined || this.mapExtended == null)) {
					this.tryInitMapWhenReady();
				}
			});
		}
		else {
			this.tryInitMapWhenReady();
		}
	}

	private tryInitMapWhenReady(): void {
		if (this.mapExtended != null) {
			return;
		}
		const start = Date.now();
		const check = () => {
			if (this.mapExtended != null) {
				return;
			}
			const googleReady = typeof (window as any).google === 'object'
				&& typeof (window as any).google.maps === 'object';
			const clustererReady = typeof (window as any).MarkerClusterer !== 'undefined';
			const spiderfierReady = typeof (window as any).OverlappingMarkerSpiderfier !== 'undefined';

			if (googleReady && clustererReady && spiderfierReady) {
				this.initMap(this.element);
				return;
			}
			if (Date.now() - start > MapExtendedComponent.MAX_WAIT_MS) {
				console.error('Google Maps or marker libraries did not load within '
					+ MapExtendedComponent.MAX_WAIT_MS + 'ms – map cannot be initialised.');
				return;
			}
			window.setTimeout(check, MapExtendedComponent.POLL_INTERVAL_MS);
		};
		check();
	}

	private getMapStyles() {
		return [
			{
				"featureType": "all", "elementType": "labels.text.fill", "stylers":
					[{ "saturation": 36 }, { "color": "#000000" }, { "lightness": 33 }]
			},
			{
				"featureType": "all", "elementType": "labels.text.stroke", "stylers":
					[{ "visibility": "on" }, { "color": "#000000" }, { "lightness": 9 }]
			},
			{
				"featureType": "all", "elementType": "labels.icon", "stylers":
					[{ "visibility": "off" }]
			}, {
				"featureType": "administrative", "elementType": "geometry.fill",
				"stylers": [{ "color": "#000000" }, { "lightness": 13 }]
			},
			{
				"featureType": "administrative", "elementType": "geometry.stroke",
				"stylers": [{ "color": "#000000" }, { "lightness": 10 }, { "weight": 1.2 }]
			},
			{
				"featureType": "administrative.country", "elementType": "geometry.stroke",
				"stylers": [{ "color": "#ffffff" }]
			},
			{
				"featureType": "landscape", "elementType": "geometry",
				"stylers": [{ "color": "#000000" }, { "lightness": 13 }]
			},
			{
				"featureType": "poi", "elementType": "geometry",
				"stylers": [{ "color": "#000000" }, { "lightness": 14 }]
			},
			{
				"featureType": "road.highway", "elementType": "geometry.fill",
				"stylers": [{ "color": "#000000" }, { "lightness": 10 }]
			},
			{
				"featureType": "road.highway", "elementType": "geometry.stroke",
				"stylers": [{ "color": "#000000" }, { "lightness": 22 }, { "weight": 0.2 }]
			},
			{
				"featureType": "road.arterial", "elementType": "geometry",
				"stylers": [{ "color": "#000000" }, { "lightness": 11 }]
			},
			{
				"featureType": "road.local", "elementType": "geometry",
				"stylers": [{ "color": "#000000" }, { "lightness": 19 }]
			},
			{
				"featureType": "transit", "elementType": "geometry",
				"stylers": [{ "color": "#000000" }, { "lightness": 12 }]
			},
			{
				"featureType": "water", "elementType": "geometry",
				"stylers": [{ "color": "#000000" }, { "lightness": 10 }]
			}];
	}

	private initMap(element: HTMLElement){
		const showMapMarkerClasses = element.getAttribute(
			'data-show-marker-classes'
		);
		const mapStyle = element.getAttribute(
			'data-map-style'
		);
		const showMapMarkerClassesList =
			showMapMarkerClasses.length > 0
				? showMapMarkerClasses.split(',')
				: [];
		const mapMarkerInformations = Array.from(
			element.getElementsByClassName('c-map-extended__information')
		);
		let mapMarkerClasses = [];
		if (mapMarkerInformations != null) {
			mapMarkerInformations.forEach(e => {
				mapMarkerClasses.push(e.getAttribute('data-marker-class'));
			});
			mapMarkerClasses = mapMarkerClasses.filter(
				(v, i, a) => a.indexOf(v) === i
			);
		}
		if(mapStyle != null && mapStyle != undefined && mapStyle === 'basic'){
			this.mapExtended = new MapExtended(element, {
				showMapMarkerClasses: showMapMarkerClassesList,
				mapMarkerClasses: mapMarkerClasses,
				mapTypes: [
					google.maps.MapTypeId.ROADMAP,
					google.maps.MapTypeId.TERRAIN,
					google.maps.MapTypeId.SATELLITE,
					google.maps.MapTypeId.HYBRID
				]
			});
		}
		else{
			const mapStylesAll = this.getMapStyles();
			this.mapExtended =new MapExtended(element, {
				showMapMarkerClasses: showMapMarkerClassesList,
				mapMarkerClasses: mapMarkerClasses,
				mapStyles: mapStylesAll,
				hasMapMarkerClassesButtonIfMultiple: true,
				styledMapName: 'Merbag'
			});
		}
	}
}